import React from "react";
import { PageLayout, Clause, Callout, Bullets } from "@/components/PageLayout";

/** Edisi Bahasa Indonesia dari Syarat Layanan. Disimpan sebagai dokumen sendiri, seperti umumnya teks hukum. */
export default function TermsOfServiceId() {
  return (
    <PageLayout
      testId="terms-of-service-page"
      eyebrow="Legal"
      title="Syarat Layanan"
      updated="1 Juni 2026"
      intro="Syarat ini mengatur penggunaan Anda atas Seleksa. Di dalamnya dijelaskan cara kerja langganan, bagaimana pembayaran diperlakukan, dan — hal yang penting bagi platform yang berdiri di antara studio dan kliennya — di mana persis tanggung jawab kami berakhir dan tanggung jawab studio dimulai."
    >
      <Clause n={1} title="Siapa yang terikat syarat ini">
        <p>
          Seleksa adalah perangkat lunak yang disediakan untuk studio foto dan fotografer lepas ("Studio"). Dengan
          membuat akun, berlangganan, atau memakai bagian mana pun dari layanan ini, Studio menerima syarat ini. Ketika
          Studio mengundang pelanggannya sendiri ("Klien") ke sebuah galeri, Klien tersebut memakai layanan di bawah
          perjanjiannya dengan Studio, bukan berdasarkan kontrak terpisah dengan Seleksa.
        </p>
        <p>
          Orang yang menyetujui syarat ini menyatakan bahwa ia berwenang mengikat Studio, dan telah cukup umur untuk
          mengadakan perjanjian di Indonesia.
        </p>
      </Clause>

      <Clause n={2} title="Langganan">
        <p>
          Seleksa dijual sebagai langganan perangkat lunak berulang. Setiap paket memberikan akses ke platform untuk
          periode tertentu — umumnya bulanan atau tahunan — yang dimulai saat pembayaran dikonfirmasi.
        </p>
        <Bullets items={[
          "Studio baru dapat memperoleh masa uji coba gratis. Uji coba dibatasi durasinya dan jumlah galeri aktifnya, serta disediakan semata untuk evaluasi.",
          "Bila periode langganan berakhir tanpa perpanjangan, akun akan terkunci: galeri yang sudah ada tetap dapat dilihat, tetapi membuat atau mengubah galeri memerlukan paket aktif.",
          "Langganan tidak diperpanjang otomatis melalui penarikan kartu secara diam-diam. Kami memberi tahu Anda sebelum masa berakhir, dan Anda yang memutuskan untuk memperpanjang.",
          "Harga paket dinyatakan dalam Rupiah (IDR). Kami dapat mengubah harga untuk periode berikutnya, tetapi tidak pernah berlaku surut untuk periode yang sudah Anda bayar.",
        ]} />
        <p>
          Kode promo dan kode afiliasi menurunkan harga periode tempat kode itu diterapkan. Kode tidak dapat diterapkan
          secara berlaku surut, tidak dapat digabungkan kecuali dinyatakan tegas, dan tidak dapat ditukar dengan uang.
        </p>
      </Clause>

      <Clause n={3} title="Pembayaran dan sifat finalnya">
        <p>
          Pembayaran langganan diproses oleh Midtrans untuk studio di Indonesia, atau oleh PayPal untuk studio yang
          membayar dari luar Indonesia. Metode Midtrans mencakup QRIS, virtual account, e-wallet,
          dan transfer bank; pembayaran PayPal ditagih dalam dolar AS sesuai harga USD tetap yang tertera pada setiap
          paket. Seleksa tidak pernah menerima maupun menyimpan data kartu atau kredensial perbankan Anda, dan kedua
          penyedia tidak berwenang menagih Anda kembali secara otomatis — setiap periode adalah pembayaran terpisah
          yang Anda putuskan sendiri.
        </p>
        <Callout tone="red">
          Semua pembayaran bersifat final. Setelah pembayaran langganan dikonfirmasi oleh Midtrans atau PayPal, pembayaran tersebut
          tidak dapat dikembalikan dan tidak dapat dibatalkan, dan periode langganan yang bersangkutan dianggap telah
          diberikan sepenuhnya.
        </Callout>
        <p>
          Ini mencerminkan sifat produknya: akses diberikan seketika dan sepenuhnya begitu pembayaran diterima, dan
          perangkat lunak tidak dapat dikembalikan. Karena itu kami meminta Anda memanfaatkan masa uji coba gratis untuk
          memastikan Seleksa cocok dengan alur kerja Anda sebelum membayar.
        </p>
        <p>
          Namun kami akan bertindak dengan itikad baik bila kesalahan ada pada kami. Jika satu periode tertagih dua
          kali, atau pembayaran yang sudah dikonfirmasi gagal mengaktifkan langganan Anda, hubungi kami dan kami akan
          memperbaikinya. Upaya chargeback yang dilakukan tanpa lebih dulu menghubungi kami dapat mengakibatkan
          penangguhan akun seketika.
        </p>
      </Clause>

      <Clause n={4} title="Hubungan Studio dengan Kliennya sendiri">
        <p>
          Ini klausul terpenting dalam dokumen ini. Seleksa menyediakan alat yang dipakai Studio untuk mengumpulkan
          pilihan foto; Seleksa bukan pihak dalam hubungan komersial antara Studio dan Kliennya.
        </p>
        <Callout tone="red">
          Studio bertanggung jawab sendiri dan sepenuhnya atas penyelesaian seluruh sengketa dengan Kliennya, serta atas
          pemenuhan setiap kewajiban pemotretan, penyuntingan, pencetakan, pemiguraan, dan pengiriman yang telah
          dijanjikannya. Seleksa tidak memikul tanggung jawab apa pun atas hal-hal tersebut.
        </Callout>
        <p>Tanpa membatasi ketentuan di atas, Studio sendirilah yang bertanggung jawab atas:</p>
        <Bullets items={[
          "Kualitas, akurasi warna, pemotongan bidang, ukuran fisik, dan ketahanan setiap produk cetak atau pigura yang diserahkan kepada Klien.",
          "Tenggat produksi, pengaturan kurir, kegagalan pengiriman, kehilangan atau kerusakan dalam pengiriman, serta pencetakan ulang yang timbul karenanya.",
          "Penagihan uang yang menjadi kewajiban Klien, termasuk biaya editan tambahan atau cetak tambahan yang dihitung Seleksa. Seleksa tidak memproses pembayaran Klien dan tidak pernah memegang uang Klien.",
          "Ketepatan harga, kuota, isi paket, dan ukuran cetak yang dikonfigurasikannya. Angka yang ditampilkan Seleksa adalah hasil hitung atas angka milik Studio sendiri.",
          "Setiap keluhan, permintaan pengembalian dana, pembatalan, atau tuntutan yang diajukan Klien, terlepas dari apakah Klien mengalaminya di dalam galeri Seleksa.",
          "Memiliki hak untuk menampilkan setiap foto yang diunggah atau dirujuknya, serta menghormati setiap izin model, lisensi, atau persetujuan yang berlaku.",
        ]} />
        <p>
          Studio setuju untuk mengganti kerugian dan membebaskan Seleksa dari setiap tuntutan, gugatan, kerugian, atau
          biaya hukum yang timbul dari sengketa dengan Kliennya, dari isi galerinya, atau dari kegagalannya menyerahkan
          apa yang telah dijanjikan.
        </p>
      </Clause>

      <Clause n={5} title="Skrip Auto-Sorter — dijalankan atas risiko Anda sendiri">
        <p>
          Seleksa dapat menghasilkan skrip otomatisasi (<code>.bat</code> untuk Windows, <code>.sh</code> untuk macOS dan
          Linux) yang merapikan file foto Studio ke folder sesuai pilihan Klien. Skrip ini berjalan di perangkat Studio
          sendiri, di bawah akun pengguna Studio sendiri, dengan izin apa pun yang dimiliki akun tersebut.
        </p>
        <Callout tone="red">
          Studio memikul tanggung jawab penuh dan tunggal atas eksekusi skrip ini. Skrip bekerja langsung pada sistem
          file Anda dan dapat memindahkan, menyalin, atau menimpa file. Seleksa tidak bertanggung jawab atas kehilangan
          data, kerusakan file, foto yang salah tempat, atau kerugian lain akibat menjalankannya.
        </Callout>
        <p>Sebelum menjalankan skrip yang dihasilkan, Studio sebaiknya:</p>
        <Bullets items={[
          "Menyiapkan salinan cadangan hasil pemotretan yang lengkap dan sudah diperiksa — idealnya di media fisik terpisah.",
          "Membuka dan membaca skripnya. Isinya teks biasa dan tindakannya bisa dibaca; jangan pernah menjalankan file yang belum Anda periksa.",
          "Memastikan jalur folder tujuan sudah benar untuk komputer Anda sebelum eksekusi.",
          "Mengujinya lebih dulu pada folder contoh berisi sedikit file saat pertama kali dipakai di komputer atau struktur folder baru.",
        ]} />
        <p>
          Seleksa tidak dapat mengetahui kondisi disk lokal Anda, apakah jalur folder Anda benar, apakah Anda memiliki
          cadangan yang sah, atau apakah program lain sedang memakai file yang sama. Kondisi tersebut di luar kendali
          kami, sehingga menjadi tanggung jawab Anda.
        </p>
      </Clause>

      <Clause n={6} title="Penggunaan yang wajar">
        <p>Studio setuju untuk tidak:</p>
        <Bullets items={[
          "Mengunggah atau merujuk konten yang melanggar hukum, atau konten yang tidak dimilikinya haknya untuk ditampilkan.",
          "Menjual kembali, memberi sublisensi, memberi label ulang, atau mengakui platform ini sebagai perangkat lunaknya sendiri, kecuali bila sebuah paket memang mengizinkan identitas visual kustom.",
          "Mencoba mengakses data studio lain, menguji atau melewati kendali akses, atau mengganggu operasional platform.",
          "Mengakali batas uji coba dengan membuat banyak akun, atau memakai satu langganan untuk beberapa usaha yang sebenarnya terpisah.",
          "Mengunggah perangkat lunak berbahaya, atau memakai layanan ini untuk menyebarkan hal yang merugikan penerimanya.",
        ]} />
        <p>
          Kami dapat menangguhkan atau menghentikan akun yang melanggar klausul ini. Bila pelanggarannya berat — konten
          melanggar hukum, atau serangan terhadap platform maupun penggunanya yang lain — kami dapat melakukannya
          seketika tanpa pengembalian dana.
        </p>
      </Clause>

      <Clause n={7} title="Ketersediaan layanan">
        <p>
          Kami berupaya menjaga Seleksa tetap tersedia dan cepat, tetapi kami tidak menjamin layanan tanpa gangguan.
          Pemeliharaan, gangguan pihak ketiga — Google Drive, Midtrans, PayPal, pengiriman email, hosting — dan peristiwa di
          luar kendali kami dapat memutus akses. Seleksa disediakan "apa adanya" dan "sebagaimana tersedia", tanpa
          jaminan beroperasi tanpa henti atau tanpa kesalahan.
        </p>
        <p>
          Karena file asli Studio tetap berada di penyimpanan Studio sendiri, gangguan pada Seleksa tidak membahayakan
          foto Anda. Meski begitu, kami menyarankan agar tenggat kepada Klien tidak dipasang begitu mepet sehingga
          beberapa jam gangguan saja sudah melanggarnya.
        </p>
      </Clause>

      <Clause n={8} title="Pembatasan tanggung jawab">
        <p>
          Sejauh diizinkan hukum Indonesia, total tanggung jawab Seleksa kepada Studio atas setiap tuntutan yang timbul
          dari atau terkait layanan ini dibatasi pada biaya langganan yang benar-benar dibayarkan Studio tersebut dalam
          tiga bulan terakhir sebelum peristiwa yang menimbulkan tuntutan.
        </p>
        <p>
          Seleksa tidak bertanggung jawab atas kerugian tidak langsung, insidental, khusus, atau konsekuensial,
          termasuk kehilangan keuntungan, kehilangan usaha, kehilangan pemesanan, kerusakan reputasi, atau biaya
          pemotretan ulang — terlepas dari dapat atau tidaknya kerugian itu diperkirakan sebelumnya.
        </p>
        <p>
          Tidak ada ketentuan dalam syarat ini yang mengesampingkan tanggung jawab yang menurut hukum tidak dapat
          dikesampingkan, termasuk tanggung jawab atas kecurangan atau atas kematian dan cedera badan akibat kelalaian.
        </p>
      </Clause>

      <Clause n={9} title="Kekayaan intelektual">
        <p>
          Studio tetap memegang seluruh hak atas fotonya. Tidak ada ketentuan di sini yang mengalihkan kepemilikan
          karya Anda kepada kami, dan kami tidak melisensikan, menjual, menerbitkan, atau memakai galeri Anda untuk
          pemasaran kami sendiri maupun untuk melatih model pembelajaran mesin. Kami hanya memegang izin teknis yang
          sempit untuk menyimpan dan menampilkan gambar Anda semata demi menjalankan layanan ini bagi Anda.
        </p>
        <p>
          Seleksa tetap memegang seluruh hak atas platformnya sendiri: perangkat lunak, antarmuka, identitas merek,
          skrip yang dihasilkan, dan dokumentasinya.
        </p>
      </Clause>

      <Clause n={10} title="Pengakhiran">
        <p>
          Studio dapat berhenti memakai Seleksa kapan saja; langganannya lalu berakhir sendiri pada akhir periode yang
          sudah dibayar. Kami dapat mengakhiri sebuah akun karena pelanggaran berat atas syarat ini, atau karena tidak
          dibayar.
        </p>
        <p>
          Sebelum pengakhiran, unduh apa yang Anda perlukan: ringkasan, invoice, dan skrip sorter. Setelah pengakhiran,
          data dihapus sesuai masa simpan yang diatur dalam Kebijakan Privasi kami.
        </p>
      </Clause>

      <Clause n={11} title="Hukum yang berlaku dan perubahan">
        <p>
          Syarat ini diatur oleh hukum Republik Indonesia, dan setiap sengketa tunduk pada yurisdiksi pengadilan di
          Kota Medan, Sumatera Utara.
        </p>
        <p>
          Kami dapat mengubah syarat ini seiring layanan berkembang, dengan memperbarui tanggal di bagian atas.
          Perubahan penting akan disampaikan kepada studio pelanggan melalui email; melanjutkan penggunaan Seleksa
          setelah perubahan berlaku berarti Anda menerimanya.
        </p>
        <p>
          Pertanyaan dapat dikirim ke{" "}
          <a href="mailto:seleksa.com@gmail.com" className="text-[#D4AF37] hover:underline">seleksa.com@gmail.com</a>.
        </p>
      </Clause>
    </PageLayout>
  );
}
